module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6682bo/master/~/vue-loader/lib/template-compiler.js?{"id":"data-v-d3a8e612"}!F:/Solutions/6682bo/master/~/vue-loader/lib/selector.js?type=template&index=0!F:/Solutions/6682bo/master/~/vue2-google-maps/dist/components/streetViewPanorama.vue
// module id = 264
// module chunks = 1